import * as Sentry from '@sentry/react'
import { Amplify } from 'aws-amplify'
import React from 'react'
import { createRoot } from 'react-dom/client'
import TagManager from 'react-gtm-module'
import {
  BrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'

import config from './amplifyconfiguration.json'
import App from './App'
import './i18n'
import './index.css'

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    environment: import.meta.env.VITE_ENVIRONMENT_NAME ?? 'development',
    // This sets the sample rate to be 10%. You may want this to be 100% while
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        createRoutesFromChildren,
        matchRoutes,
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
      }),
      Sentry.replayIntegration({
        blockAllMedia: true,
        // Additional SDK configuration goes in here, for example:
        maskAllText: true,
      }),
    ],
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: import.meta.env.DEV ? 1.0 : 0.1,
    tracesSampleRate: 1.0,
  })
}

Amplify.configure(config)

const tagManagerArgs = {
  gtmId: import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID ?? '',
}

if (tagManagerArgs.gtmId) {
  TagManager.initialize(tagManagerArgs)
}

const root = createRoot(document.getElementById('root')!)

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
